<template>
  <div class="stepper-wrapper my-4">
    <div class="stepper-item" id="step-i-1" :class="{ active: step === 1 }">
      <div class="step-counter">1</div>
      <div class="step-name">Data e Período</div>
    </div>
    <div class="stepper-item" id="step-i-1" :class="{ active: step === 2 }">
      <div class="step-counter">2</div>
      <div class="step-name">Grupos</div>
    </div>
    <div class="stepper-item" id="step-i-2" :class="{ active: step === 3 }">
      <div class="step-counter">3</div>
      <div class="step-name">Cidades de Prova</div>
    </div>
    <div class="stepper-item" id="step-i-3" :class="{ active: step === 4 }">
      <div class="step-counter">4</div>
      <div class="step-name">Colégios</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['step']
}
</script>
<style scoped>
.stepper-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.stepper-item::before {
  position: absolute;
  content: '';
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 1;
}
.stepper-item:first-child::before {
  content: none;
}
.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  color: white;
  margin-bottom: 6px;
  font-weight: bold;
}
.stepper-item.active .step-counter {
  background-color: #a90637;
}
.stepper-item.completed .step-counter {
  background-color: #198754;
}
.stepper-item.completed::before {
  border-color: #198754;
}

.step {
  display: none;
}
.step.active {
  display: block;
}
</style>